import ServiceExec from '@/common/utils/ServiceExec';
import { pos } from '@/common/service/ApiList';

export default {
  async FETCH_CONNECTION({ commit }, { storeNo, skipLoading = false }) {
    const response = await ServiceExec.get(pos.connection(storeNo), {}, { skipLoading });
    if (response.status === 200) commit('setConnection', response.data);
    if (response.status === 204) commit('clear');
    return response;
  },
  async FETCH_RUNS({ commit }, { storeNo, skipLoading = false }) {
    const response = await ServiceExec.get(pos.syncRuns(storeNo), {}, { skipLoading });
    if (response.status === 200) commit('setRuns', response.data ?? []);
    return response;
  },
  async FETCH_RUN({ commit }, { storeNo, syncRunNo, skipLoading = false }) {
    const response = await ServiceExec.get(pos.syncRun(storeNo, syncRunNo), { _: Date.now() }, { skipLoading });
    if (response.status === 200) commit('setSyncRun', response.data);
    return response;
  },
  async FETCH_ISSUES({ commit }, { storeNo, skipLoading = false }) {
    const response = await ServiceExec.get(pos.issues(storeNo), { status: 'OPEN' }, { skipLoading });
    if (response.status === 200) commit('setIssues', response.data ?? []);
    return response;
  },
  async REQUEST_SYNC({ commit }, storeNo) {
    const response = await ServiceExec.post(pos.sync(storeNo));
    if (response.status === 202) commit('setSyncRun', response.data);
    return response;
  },
  async DISCONNECT({ commit }, { storeNo, force }) {
    const response = await ServiceExec.delete(pos.connection(storeNo), { force });
    if (response.status === 204) commit('clear');
    return response;
  }
};
